import React from 'react'
import { t } from 'i18next'
import Image from 'next/image'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import { Constants } from 'app/app/(client)/utils/client-constants'

interface NoSearchResultsProps {
  className?: string
}

const NoSearchResults: React.FC<NoSearchResultsProps> = ({ className }) => (
  <div className={`flex flex-col justify-center items-center gap-12 mt-6 ${className || ''}`}>
    <Image src={Constants.NO_RESULT_FOUND_IMAGE} alt="No results found" width={583} height={400} />
    <Text id="no-search-results-text" as="div" className={`text-center text-22px font-normal`}>
      {t('customers.refresh.noSearchResults')}
    </Text>
  </div>
)

export default NoSearchResults
